export default {
    _prefix: "agentScoringRules.table",
    labels: {
        description:
            "Create agent scoring rules for your program. Choose how many interactions you want to analyze, then select an evaluation form to score agents automatically. Scores are generated from the selected form and appear in relevant areas, such as the interaction details screen.",
        noteLabel: "Note:",
        maxRulesNote: (data: { count: number }) =>
            "You can create up to {{count}} agent scoring rules per program.",
        newRule: "New Rule",
        newRuleTooltip: "Create a new agent scoring rule",
        maxRulesReachedTooltip: (data: { count: number }) =>
            "Maximum of {{count}} agent scoring rules reached",
        noAddPermissionTooltip: "You do not have permission to add rules",
        loading: "Loading agent scoring rules",
        emptyMessage: "No Rules Created",
        loadFailedMessage:
            "Unable to load agent scoring rules. Please try again.",
        status: {
            enabled: "Enabled",
            disabled: "Disabled",
        },
        columns: {
            ruleSelectionCriteria: "Rule Selection Criteria",
            ruleForm: "Rule Form",
            status: "Status",
            actions: "Actions",
        },
        actions: {
            editTooltip: "Edit rule",
            deleteTooltip: "Delete rule",
            noEditPermissionTooltip: "You do not have permission to edit rules",
            noDeletePermissionTooltip:
                "You do not have permission to delete rules",
        },
        samplingType: {
            all: "All Interactions",
            percentage: "Percentage of Interactions",
        },
    },
};
